import React, {
  Dispatch, SetStateAction, useEffect, useState,
} from 'react'
import { useTranslation } from 'react-i18next'
import useCertificatesInfoApi from './hooks/useCertificateInfo/api'
import { TabType } from '../index'
import CertificateInfoTableRow from './CertificateInfoTableRow'
import { parseCertificateInfoResponses } from './hooks/useCertificateInfo/mapper'
import { CertificateInfo } from './models/certificate-info'

interface CertificatesTabProps {
  loading: boolean
  setLoading: Dispatch<SetStateAction<boolean>>
  // eslint-disable-next-line react/no-unused-prop-types
  readonly tabType: TabType
}

function CertificatesTab(props: Readonly<CertificatesTabProps>) {
  const [certificates, setCertificates] = useState<CertificateInfo[]>([])
  const { t } = useTranslation()

  const {
    fetchCertificatesInfo,
  } = useCertificatesInfoApi()

  useEffect(() => {
    if (fetchCertificatesInfo.data) {
      setCertificates(parseCertificateInfoResponses(fetchCertificatesInfo.data.data))
    }
  }, [fetchCertificatesInfo.data])

  return (
    <div className="container-fluid py-3 certificates__body">
      <div className="row">
        <div className="col-12">
          <div className="table-responsive">
            <table
              className="table table-responsive table-striped table-bordered table-declaration"
            >
              <thead>
                <tr>
                  <th>{t('certificates.expiry')}</th>
                  <th>{t('certificates.validTo')}</th>
                  <th>{t('certificates.name')}</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {certificates.map((row, index) => (
                  <React.Fragment key={`${row.id} + ${certificates.length}`}>
                    <CertificateInfoTableRow index={index} certificateInfo={row} />
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CertificatesTab
